// extracted by mini-css-extract-plugin
module.exports = {"input":"EditableInput_input__1Cwew","editable":"EditableInput_editable__3ccTp"};